export const truckTypes = {
  FLATBED: 'flatbed',
  VAN: 'van',
  REEFER: 'reefer',
}

export const sortTypes = {
  STATE: 'state',
  RATIO: 'ratio'
}


export const sortEnum = Object.values(sortTypes);


// WEBPACK FOOTER //
// ./src/components/CapacityRatio/types.js